export default __webpack_public_path__ + "dist/media/Pencil-draw-bg.b2d80b1c.svg";